import { useState } from "react"; 

import Mediacion from "../formularios/Mediacion";
import classes from "./MediacionModal.module.css";
import cancel from "../../img/icono_cancel.png";

function ModalMediacion(props) {
  const [modal_cierre_visible, setModal_cierre_visible] = useState(
    false
  );

  function closeModal() {
    props.setShowModalMediacion(false);
  }
  
  function funcionesCierre(event) {
    event.stopPropagation();
    setModal_cierre_visible(true);

  }

  return (
    <div
      className={classes.modalContainer}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <div
        className={classes.modal}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div
          className={classes.closeModal}
          onClick={funcionesCierre}
        >
          <img className={classes.closeModal} src={cancel} alt="" />
        </div>
        <div>
          <Mediacion
            closeModal={closeModal}
            caso={props.caso}
            key={props.caso ? props.caso.ruc : Date.now()}
            modal_cierre_visible= {modal_cierre_visible}
            setModal_cierre_visible = {setModal_cierre_visible}
          ></Mediacion>
        </div>
      </div>
    </div>
  );
}

export default ModalMediacion;
